import Cookies from "js-cookie";
import React, { useContext, useEffect, useState } from "react";
import config from "../../config/apiConfig";
import UserContext from "../../context/UserContext";
import { useQuery } from "../../utils/hooks";
import ReactGA from "react-ga";
import { Redirect } from "react-router-dom";
import { getRedirection } from "../../utils/widgets";

const AuthSSO: React.FC = () => {
    const query = useQuery();

    const token = query.get("token");
    const gr = query.get("gr");

    const [error, setError] = useState("");
    const [loggedIn, setLoggedIn] = useState(false);
    const [status, setStatus] = useState("");
    // @ts-ignore
    const [ user, setUser ] = useContext(UserContext);

    useEffect(() => {
        if (Cookies.get("token") != undefined) {
            setLoggedIn(true);
        }
    }, []);

    useEffect(() => {
        handleLogin();
    }, [token, gr]);

    const handleLogin = () => {
        if (!token || !gr) {
            setError("Invalid token");
            return;
        }

        const formData = new FormData();
        formData.append("auth_token", token);
        formData.append("gr", gr);
        formData.append("token", config.token);
        formData.append("session-token", "AUTH");
        formData.append("device", "web");
        formData.append("user_ip", "120.12.22.130");
        formData.append("user_agent", "Mozilla 1");
        const requestOptions = {
            method: "POST",
            body: formData,
        };
        fetch(config.BASE_URL + "/idam/user/sso_login", requestOptions)
            .then((response) => response.json())
            .then((resp) => {
                console.log(resp);
                if (resp.is_error) {
                    setError(resp.error_msg);
                } else {
                    Cookies.set("token", resp.data.session_token);
                    Cookies.set("id", resp.data.user_id);
                    Cookies.set("info", JSON.stringify(resp.data.user_info));
                    Cookies.set("auth_token", token);

                    setStatus(resp.data.status);
                    // @ts-ignore
                    setUser({ resp });
                    setLoggedIn(true);
                    ReactGA.event({
                        category: "AUTH",
                        action: "Login Account",
                        label: resp.data.user_id,
                    });
                }
            });
    };

    return (
        <UserContext.Consumer>
            {(user) => {
                // @ts-ignore
                if (user[0].resp?.status === "success") {
                    if (status === "signup_onboarding") {
                        console.log("SELECT PREF");
                    }
                    return status === "signup_onboarding" ? (
                        <Redirect to="/signup/preferences" />
                    ) : (
                        getRedirection()
                    );
                }
                if (loggedIn) {
                    return getRedirection();
                }
                return (
                    <div></div>
                );
            }}
        </UserContext.Consumer>
    );
};

export default AuthSSO;
